import React from "react";
import DashboardIcon from "@material-ui/icons/Dashboard";
import GroupIcon from "@material-ui/icons/Group";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import SecurityIcon from "@material-ui/icons/Security";
import EmailIcon from "@material-ui/icons/Email";
import WorkIcon from "@material-ui/icons/Work";
import BusinessIcon from "@material-ui/icons/Business";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import SettingsIcon from "@material-ui/icons/Settings";
import TenantIssuerIcon from "@material-ui/icons/BrandingWatermark";
import CfdisIcon from "@material-ui/icons/CreateNewFolder";
import CfdisPendingIcon from "@material-ui/icons/Receipt";
import CfdisArchiveIcon from "@material-ui/icons/Archive";
import CfdisValidatingIcon from "@material-ui/icons/AssignmentTurnedIn";
import CfdisWaitingIcon from "@material-ui/icons/AccountBalanceWallet";
import CfdisPendingCfdiIcon from "@material-ui/icons/NewReleases";
import CfdisCancelledIcon from "@material-ui/icons/RemoveCircle";
import PaymentsIcon from "@material-ui/icons/AccountBalanceWallet";
import PaymentsPendingIcon from "@material-ui/icons/AssignmentTurnedIn";
import PaymentsArchiveIcon from "@material-ui/icons/Archive";
import CustomerDocumentIcon from "@material-ui/icons/FolderShared";
import CustomerSigninsIcon from "@material-ui/icons/Assessment";
import ProductsCatalogIcon from "@material-ui/icons/ViewList";

import Dashboard from "../dashboard/Dashboard";
import Users from "../users/Users";
import UserProfile from "../users/UserProfile";
import UserSecurity from "../users/UserSecurity";
import UserForm from "../users/UserForm";
import VerifyEmail from "../auth/VerifyEmail";
import Tenants from "../tenants/Tenants";
import TenantForm from "../tenants/TenantForm";
import { CustomersGeneral, CustomersDocuments, CustomersSignins } from "../customers/Customers";
import CustomerForm from "../customers/CustomerForm";
import KeyPairs from "../keypairs/KeyPairs";
import KeyPairForm from "../keypairs/KeyPairForm";
import TenantIssuerForm from "../tenants_issuers/TenantIssuerForm";
import TenantIssuerProductCatalogUploader from "../tenants_issuers/TenantIssuerProductCatalogUploader";
import { AllCfdisList, PendingCfdisList, WaitingCfdisList, ValidatingCfdisList, PendingCfdiCfdisList, CancelledCfdisList } from "../cfdis/Cfdis";
import { AllPayments, PendingPayments, PendingCustomerPayments, AllCustomerPayments } from "../payments/Payments";
import Payment from "../payments/Payment";
import Documents from "../documents/Documents";
import DocumentForm from "../documents/DocumentForm";
import CustomerDocument from "../customers_documents/CustomerDocument";

export const routes = [
    {
        title: "dashboard.title",
        path: "/",
        icon: <DashboardIcon />,
        component: Dashboard,
        exact: true,
    } as RouteItem,
    {
        title: "users.profile.title",
        path: "/profile",
        icon: <AccountCircleIcon />,
        component: UserProfile,
        hidden: true,
    } as RouteItem,
    {
        title: "auth.verify_email.title",
        path: "/verify-email/:code",
        icon: <EmailIcon />,
        component: VerifyEmail,
        hidden: true,
    } as RouteItem,
    {
        title: "users.security.title",
        path: "/security",
        icon: <SecurityIcon />,
        component: UserSecurity,
        hidden: true,
    } as RouteItem,
    {
        title: "cfdis.title",
        path: "",
        icon: <CfdisIcon />,
        grants: ["CfdisRead", "CustomersCfdisRead"],
        items: [
            {
                title: "cfdis.payment_status.pending",
                path: "/cfdis/pending",
                icon: <CfdisPendingIcon />,
                component: PendingCfdisList,
            } as RouteItem,
            {
                title: "cfdis.payment_status.waiting",
                path: "/cfdis/waiting",
                icon: <CfdisWaitingIcon />,
                component: WaitingCfdisList,
            } as RouteItem,
            {
                title: "cfdis.payment_status.validating",
                path: "/cfdis/validating",
                icon: <CfdisValidatingIcon />,
                component: ValidatingCfdisList,
            } as RouteItem,
            {
                title: "cfdis.payment_status.pending_cfdi",
                path: "/cfdis/pending-cfdi",
                icon: <CfdisPendingCfdiIcon />,
                component: PendingCfdiCfdisList,
            } as RouteItem,
            {
                title: "cfdis.payment_status.cancelled",
                path: "/cfdis/cancelled",
                icon: <CfdisCancelledIcon />,
                component: CancelledCfdisList,
            } as RouteItem,
            {
                title: "cfdis.payment_status.all",
                path: "/cfdis",
                icon: <CfdisArchiveIcon />,
                component: AllCfdisList,
            } as RouteItem,
        ]
    } as RouteItem,
    {
        title: "payments.title",
        path: "",
        icon: <PaymentsIcon />,
        grants: ["CustomersPaymentsRead"],
        items: [
            {
                title: "payments.status.processing",
                path: "/payments/pending",
                icon: <PaymentsPendingIcon />,
                component: PendingCustomerPayments,
                grants: ["CustomersPaymentsRead"],
            } as RouteItem,
            {
                title: "payments.title",
                path: "/payments/:paymentId",
                icon: <PaymentsIcon />,
                component: Payment,
                grants: ["CustomersPaymentsRead"],
                hidden: true
            },
            {
                title: "payments.status.all",
                path: "/payments",
                icon: <PaymentsArchiveIcon />,
                component: AllCustomerPayments,
                grants: ["CustomersPaymentsRead"],
            } as RouteItem
        ]
    } as RouteItem,
    {
        title: "payments.title",
        path: "",
        icon: <PaymentsIcon />,
        grants: ["PaymentsRead"],
        items: [
            {
                title: "payments.status.VALIDATING",
                path: "/payments/pending",
                icon: <PaymentsPendingIcon />,
                component: PendingPayments,
            },
            {
                title: "payments.title",
                path: "/payments/:paymentId",
                icon: <PaymentsIcon />,
                component: Payment,
                hidden: true
            },
            {
                title: "payments.status.all",
                path: "/payments",
                icon: <PaymentsArchiveIcon />,
                component: AllPayments,
            } as RouteItem
        ]
    } as RouteItem,
    {
        title: "cfdis.title",
        path: "/customers/:customerId/cfdis",
        icon: <CfdisIcon />,
        component: AllCfdisList,
        grants: ["CfdisRead"],
        hidden: true,
    } as RouteItem,
    {
        title: "cfdis.title",
        path: "/customers/:customerId/documents",
        icon: <CustomerDocumentIcon />,
        component: CustomerDocument,
        grants: ["DocumentsRead"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/customers/:customerId/users/new",
        icon: <GroupIcon />,
        component: UserForm,
        grants: ["TenantsCustomersUsersCreate", "CustomersUsersCreate"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/customers/:customerId/users/:userId/edit",
        icon: <GroupIcon />,
        component: UserForm,
        grants: ["TenantsCustomersUsersUpdate", "CustomersUsersUpdate"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/customers/:customerId/users",
        icon: <GroupIcon />,
        component: Users,
        grants: ["TenantsCustomersUsersRead", "CustomersUsersRead"],
        hidden: true,
    } as RouteItem,
    {
        title: "customers.title",
        path: "/customers/new",
        icon: <BusinessIcon />,
        component: CustomerForm,
        grants: ["CustomersCreate"],
        hidden: true
    } as RouteItem,
    {
        title: "customers.title",
        path: "/customers/:customerId/edit",
        icon: <BusinessIcon />,
        component: CustomerForm,
        grants: ["CustomersUpdate"],
        hidden: true
    } as RouteItem,
    {
        title: "customers.title",
        path: "",
        icon: <BusinessIcon />,
        grants: ["CustomersRead"],
        items: [
            {
                title: "customers.general",
                path: "/customers/general",
                icon: <BusinessIcon />,
                component: CustomersGeneral,
            } as RouteItem,
            {
                title: "customers.documents",
                path: "/customers/documents",
                icon: <CustomerDocumentIcon />,
                component: CustomersDocuments
            },
            {
                title: "customers.signins",
                path: "/customers/signins",
                icon: <CustomerSigninsIcon />,
                component: CustomersSignins
            },
            {
                title: "customers.general",
                path: "/customers",
                icon: <BusinessIcon />,
                component: CustomersGeneral,
                hidden: true
            } as RouteItem,
        ]
    } as RouteItem,
    {
        title: "users.title",
        path: "/tenants/:tenantId/users/new",
        icon: <GroupIcon />,
        component: UserForm,
        grants: ["UsersCreate"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/tenants/:tenantId/users/:userId/edit",
        icon: <GroupIcon />,
        component: UserForm,
        grants: ["UsersUpdate"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/tenants/:tenantId/users",
        icon: <GroupIcon />,
        component: Users,
        grants: ["UsersRead"],
        hidden: true,
    } as RouteItem,
    {
        title: "tenants.new_tenant",
        path: "/tenants/:tenantId/edit",
        icon: <WorkIcon />,
        component: TenantForm,
        grants: ["TenantsUpdate"],
        hidden: true,
    } as RouteItem,
    {
        title: "tenants.new_tenant",
        path: "/tenants/new",
        icon: <WorkIcon />,
        component: TenantForm,
        grants: ["TenantsCreate"],
        hidden: true,
    } as RouteItem,
    {
        title: "tenants.title",
        path: "/tenants",
        icon: <WorkIcon />,
        component: Tenants,
        grants: ["TenantsRead"],
    } as RouteItem,
    {
        title: "users.title",
        path: "/users/new",
        icon: <GroupIcon />,
        component: UserForm,
        grants: ["UsersCreate", "TenantsUsersCreate"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/users/:userId/edit",
        icon: <GroupIcon />,
        component: UserForm,
        grants: ["UsersUpdate", "TenantsUsersUpdate"],
        hidden: true,
    } as RouteItem,
    {
        title: "users.title",
        path: "/users",
        icon: <GroupIcon />,
        component: Users,
        grants: ["UsersRead", "TenantsUsersRead", "CustomersUsersRead"],
    } as RouteItem,
    {
        title: "documents.title",
        path: "/documents",
        icon: <CustomerDocumentIcon />,
        component: CustomerDocument,
        grants: ["CustomersDocumentsRead"],
        hidden: true,
    } as RouteItem,
    {
        title: "settings.title",
        path: "",
        icon: <SettingsIcon />,
        grants: ["KeyPairsRead"],
        items: [
            {
                title: "documents.title",
                path: "/documents/new",
                icon: <CustomerDocumentIcon />,
                component: DocumentForm,
                grants: ["DocumentsCreate"],
                hidden: true
            } as RouteItem,
            {
                title: "documents.title",
                path: "/documents/:documentId",
                icon: <CustomerDocumentIcon />,
                component: DocumentForm,
                grants: ["DocumentsUpdate"],
                hidden: true
            } as RouteItem,
            {
                title: "documents.title",
                path: "/documents",
                icon: <CustomerDocumentIcon />,
                component: Documents,
                grants: ["DocumentsRead"],
            } as RouteItem,
            {
                title: "tenants_issuers.products_catalog.title",
                path: "/issuance/products-catalog",
                icon: <ProductsCatalogIcon />,
                component: TenantIssuerProductCatalogUploader,
                grants: ["TenantsSettingsProductsCatalog"]
            } as RouteItem,
            {
                title: "tenants_issuers.title",
                path: "/issuance",
                icon: <TenantIssuerIcon />,
                component: TenantIssuerForm,
                grants: ["TenantsIssuersRead"],
            } as RouteItem,
            {
                title: "keypairs.title",
                path: "/keypairs/new",
                icon: <VpnKeyIcon />,
                component: KeyPairForm,
                grants: ["KeyPairsCreate"],
                hidden: true
            } as RouteItem,
            {
                title: "keypairs.title",
                path: "/keypairs/:keyPairId",
                icon: <VpnKeyIcon />,
                component: KeyPairForm,
                grants: ["KeyPairsUpdate"],
                hidden: true
            } as RouteItem,
            {
                title: "keypairs.title",
                path: "/keypairs",
                icon: <VpnKeyIcon />,
                component: KeyPairs,
                grants: ["KeyPairsRead"],
            } as RouteItem
        ]
    } as RouteItem
] as RouteItem[];

export interface RouteItem {
    title: string;
    path: string;
    icon: React.ReactElement;
    component?: React.FunctionComponent;
    exact?: boolean;
    grants?: string[];
    exclude?: string[];
    items?: RouteItem[];
    hidden?: boolean;
    skip_route?: boolean;
}
